import React from 'react';
import clsx from 'clsx';
import { isBoolean } from 'src/utils/typeGuards';
import styles from './Status.module.less';

export enum Status {
  Active = 'Active',
  Inactive = 'Inactive',
  Mixed = 'Mixed',
}

export namespace Status {
  export const fromBoolean = (isActive: boolean): Status => {
    return isActive ? Status.Active : Status.Inactive;
  };
}

const statusMap = {
  [Status.Active]: styles.active,
  [Status.Inactive]: styles.inactive,
  [Status.Mixed]: styles.mixed,
} as const;

type StatusCircleProps = {
  value: boolean | Status;
};
export const StatusCircle = ({ value }: StatusCircleProps) => {
  const key = isBoolean(value) ? Status.fromBoolean(value) : value;
  return (
    <>
      <span className={clsx(styles.status, statusMap[key])} />
      {key}
    </>
  );
};
